module.exports = __webpack_public_path__ + "img/mobilebanner1.7a676b37.png";